import { cn } from "@/lib/utils";

// Conic-gradient angles start at 12 o'clock and run clockwise, so 0deg is the
// top edge and 180deg-360deg is everything left of centre.
//
// At rest / on hover: a narrow bright band at 0deg, matching the form fields'
// TopSheen, which spins around the perimeter on hover.
const SHEEN_TOP_BAND =
  "bg-[conic-gradient(rgba(255,255,255,0.9)_0deg,transparent_40deg,transparent_320deg,rgba(255,255,255,0.9)_360deg)]";

// Selected: brightest on the left edge (270deg), easing all the way round to
// grey on the right (90deg).
//
// The silver covers three quarters of the ring: the grey dip is confined to
// 45-135deg, leaving 135deg->360deg->45deg — 270 of 360 degrees — lit.
//
// Opaque greys rather than `transparent` at the dim end, and gradual stops
// rather than a hard cut: an earlier version jumped from full silver to nothing
// over 20 degrees, which read as the gradient stopping dead instead of turning
// to grey. #C9D1D9 and #6E7681 are the palette's own greys, and #3A3F47 lands
// about where the unselected ring's white/20 sits, so the two states share a
// floor.
const SHEEN_LEFT_HALF =
  "bg-[conic-gradient(#C9D1D9_0deg,#6E7681_45deg,#3A3F47_90deg,#6E7681_135deg,#C9D1D9_180deg,#FFFFFF_270deg,#C9D1D9_360deg)]";

/**
 * The gradient highlight that lives inside a card's border ring.
 *
 * Expects a parent that is `group relative overflow-hidden` with a 1px padding
 * gap around an opaque inner panel — that gap is the border, and this is what
 * lights it. Unselected it rests on the top edge and spins on hover; selected
 * it stops spinning and lights the card's whole left half instead.
 */
export function SheenRing({ selected }: { selected: boolean }) {
  return (
    <span
      aria-hidden
      className={cn(
        "pointer-events-none absolute left-1/2 top-1/2 aspect-square w-[200%] -translate-x-1/2 -translate-y-1/2",
        selected
          ? SHEEN_LEFT_HALF
          : `${SHEEN_TOP_BAND} group-hover:animate-border-spin motion-reduce:animate-none`,
      )}
    />
  );
}
